import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { LoginForm } from "@/features/auth/components/LoginForm";
import { Stack } from "@mui/material";
import { FC } from "react";

type TLoginPageProps = {};

export const LoginPage: FC<TLoginPageProps> = () => {
  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <LoginForm />
    </Stack>
  );
};
